import React, { useState, useEffect } from 'react';
import { Navigation } from './Navigation';
import { API_BASE_URL } from '../services/api';

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  const [serverStatus, setServerStatus] = useState<'checking' | 'online' | 'offline'>('checking');

  useEffect(() => {
    checkServerStatus();
    // Проверяем статус сервера каждые 30 секунд
    const interval = setInterval(checkServerStatus, 30000);
    return () => clearInterval(interval);
  }, []);

  const checkServerStatus = async () => {
    try {
      // Пробуем обратиться к простому API эндпоинту
      const response = await fetch(`${API_BASE_URL}/Company/Get?id=1`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      if (response.ok || response.status === 404) { // 404 нормально, если компании с ID 1 нет
        setServerStatus('online');
      } else {
        setServerStatus('offline');
      }
    } catch (error) {
      setServerStatus('offline');
    }
  };

  return (
    <div className="app">
      <Navigation />
      <div style={{
        padding: '8px 20px',
        backgroundColor: serverStatus === 'offline' ? '#ffebee' : '#e8f5e8',
        borderBottom: `1px solid ${serverStatus === 'offline' ? '#f44336' : '#4caf50'}`,
        fontSize: '12px',
        display: 'flex',
        alignItems: 'center',
        gap: '8px'
      }}>
        <div style={{
          width: '6px',
          height: '6px',
          borderRadius: '50%',
          backgroundColor: serverStatus === 'online' ? '#4caf50' : serverStatus === 'checking' ? '#ff9800' : '#f44336'
        }}></div>
        <span style={{ color: '#666' }}>
          {serverStatus === 'online' && 'Сервер доступен'}
          {serverStatus === 'offline' && 'Сервер недоступен - запустите backend-приложение'}
          {serverStatus === 'checking' && 'Проверка подключения...'}
        </span>
      </div>
      <main className="main-content">
        {children}
      </main>
    </div>
  );
};

